<hc-modal class="cdp-tenant-switcher-splash">
    <hc-modal-body>
        <cdp-tenant-switcher [isInDropdown]="false" (tenantSelected)="onTenantSelected()"></cdp-tenant-switcher>
    </hc-modal-body>
</hc-modal>
